export const setDPI = dpi => {
  if (typeof window === "undefined") return
  Object.defineProperty(window, "devicePixelRatio", {
    get: function() {
      return dpi / 96
    }
  })
}
